import React from "react";
import { Plus, Trash2, Filter } from "lucide-react";

const OPS = [
  { value: "eq", label: "equals" },
  { value: "ne", label: "not equals" },
  { value: "contains", label: "contains" },
  { value: "starts_with", label: "starts with" },
  { value: "gt", label: ">" },
  { value: "lt", label: "<" },
  { value: "regex", label: "regex" },
  { value: "not_empty", label: "not empty" },
];

export default function ConditionsBlock({ rule, index, onChange }) {
  const conditions = rule.conditions || [];
  const update = (ki, field, value) => {
    const cs = [...conditions];
    cs[ki] = { ...cs[ki], [field]: value };
    onChange({ ...rule, conditions: cs });
  };
  const add = () => onChange({ ...rule, conditions: [...conditions, { side: "a", col: "", op: "eq", value: "" }] });
  const remove = (ki) => onChange({ ...rule, conditions: conditions.filter((_, i) => i !== ki) });

  return (
    <div style={{ marginTop: "1rem", padding: "0.75rem", background: "#F1F5F9", border: "1px solid #CBD5E1", borderRadius: "0.5rem" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: conditions.length > 0 ? "0.5rem" : 0 }}>
        <p style={{ fontSize: "0.78rem", fontWeight: 600, color: "#334155", margin: 0, textTransform: "uppercase", letterSpacing: "0.05em", display: "flex", alignItems: "center", gap: "0.375rem" }}>
          <Filter size={12} /> Conditions (optional)
          <span style={{ fontSize: "0.7rem", fontWeight: 400, color: "var(--text-muted)", textTransform: "none", letterSpacing: 0 }}>
            — rule only applies when all conditions match
          </span>
        </p>
        <button data-testid={`add-cond-${index}`} onClick={add}
          style={{ display: "flex", alignItems: "center", gap: "0.25rem", fontSize: "0.75rem", color: "#334155", background: "none", border: "none", cursor: "pointer" }}>
          <Plus size={12} /> Add condition
        </button>
      </div>
      {conditions.map((c, ki) => (
        <div key={ki} style={{ display: "grid", gridTemplateColumns: "70px 1fr 120px 1fr auto", gap: "0.375rem", marginBottom: "0.25rem", alignItems: "center" }}>
          <select data-testid={`cond-side-${index}-${ki}`} className="recon-input" style={{ fontSize: "0.78rem" }}
            value={c.side || "a"} onChange={e => update(ki, "side", e.target.value)}>
            <option value="a">File A</option>
            <option value="b">File B</option>
          </select>
          <input data-testid={`cond-col-${index}-${ki}`} className="recon-input" style={{ fontSize: "0.78rem", fontFamily: "JetBrains Mono, monospace" }}
            value={c.col || ""} onChange={e => update(ki, "col", e.target.value)} placeholder="column" />
          <select data-testid={`cond-op-${index}-${ki}`} className="recon-input" style={{ fontSize: "0.78rem" }}
            value={c.op || "eq"} onChange={e => update(ki, "op", e.target.value)}>
            {OPS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <input data-testid={`cond-val-${index}-${ki}`} className="recon-input" style={{ fontSize: "0.78rem", fontFamily: "JetBrains Mono, monospace" }}
            value={c.value || ""} onChange={e => update(ki, "value", e.target.value)}
            placeholder={c.op === "not_empty" ? "(no value needed)" : "value"}
            disabled={c.op === "not_empty"} />
          <button onClick={() => remove(ki)} style={{ background: "none", border: "none", cursor: "pointer", color: "#DC2626" }}>
            <Trash2 size={11} />
          </button>
        </div>
      ))}
    </div>
  );
}
